import styled, { css } from "styled-components";

const color = ({ $outline, theme }) => {
  if ($outline) return theme.colors.feedbackState.success.default;

  return theme.colors.neutral.white;
};

const backgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.feedbackState.success.default;
};

const hoverBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return theme.colors.feedbackState.success.disabled;

  return theme.colors.feedbackState.success.hover;
};

const outline = ({ $outline, theme }) => {
  if ($outline)
    return `2px solid ${theme.colors.feedbackState.success.default} `;

  return "none";
};

const focusBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.feedbackState.success.default;
};

const focusOutline = ({ theme }) => {
  return `4px solid ${theme.colors.feedbackState.success.hover}`;
};

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px;
`;

export const SuccessButtonStructure = css`
  color: ${color};
  background-color: ${backgroundColor};
  border: ${outline};

  &:hover:not([disabled]) {
    background-color: ${hoverBackgroundColor};
  }

  &:focus {
    background-color: ${focusBackgroundColor};
    outline: ${focusOutline};
  }
`;
